import script from "./FinishedTestsListNew.vue?vue&type=script&setup=true&lang=js"
export * from "./FinishedTestsListNew.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__